<template>
  <div class="Sobre" v-if="!is_mobile">
    <div class="libe_home_nav animate__animated animate__fadeInDown" v-if="scroll >= 88">
      <headNav :activeNav="'sobre'"></headNav>
    </div>
    <div class="eshoy_content_wrap">
      <div class="libe_homenav" v-if="scroll < 88 ">
        <homeNav :activeNav="'sobre'"></homeNav>
      </div>

      <div id="lalanitasobre_pcmax" class="lalanitasobre_1v">
          <div class="common_problem_wrap">
              <div id="common_problem_tabs" class="common_problem_tab">
                  <van-tabs type="card">
                      <van-tab title="Preguntas de solicitud">
                          <div class="common_children_wrap">
                              <div class="common_children_title">Cuestiones de préstamo</div>
                              <van-collapse :border="hasborder" v-model="chidthr_Names">
                                  <van-collapse-item :border="hasborder" name="1">
                                      <template #title>
                                          <div class="children_title_wrap">
                                              <div class="children_title_left">
                                                  <div class="children_tleft_text">¿Cuáles son los requisitos para solicitar un préstamo?</div>
                                              </div>
                                          </div>
                                      </template>

                                      <template #right-icon>
                                          <div class="common_title_right" style="padding-top: 0.5rem;">
                                              <div class="common_trview" style="width: 0.666667rem; height: 0.666667rem;">
                                                  <img v-if="chidthrIsOpen('1')" src="../assets/imgs/arrow_icon_up.webp" alt="" />
                                                  <img v-else src="../assets/imgs/arrow_icon_down.webp" alt="" />
                                              </div>
                                          </div>
                                      </template>
                                      <div class="children_solid_v">
                                          <div class="children_solid"></div>
                                      </div>
                                      <div class="children_cont">
                                          <div class="children_cont_items">
                                              Para solicitar un préstamo en LaLANITAplus, necesitas cumplir con lo siguiente:
                                              <br/> Ser ciudadano mexicano mayor de 18 años.
                                              <br/> Tener una cuenta bancaria en México.
                                              <br/> Estar dentro del territorio mexicano y contar con tu identificación oficial mexicana.
                                              <br/> La solicitud de préstamo debe ser realizada por ti mismo.
                                              Si no cumples con estos requisitos, tu solicitud de préstamo no podrá ser aprobada.
                                              No requerimos ningún tipo de pago anticipado. Solo necesitas registrarte con tu número de teléfono, completar tu información personal y enviar tu solicitud de préstamo; ¡todo el proceso es completamente gratuito!
                                          </div>
                                      </div>
                                  </van-collapse-item>

                                  <van-collapse-item :border="hasborder" name="2">
                                      <template #title>
                                          <div class="children_title_wrap">
                                              <div class="children_title_left">
                                                  <div class="children_tleft_text">¿Qué documentos necesito para solicitar un préstamo?</div>
                                              </div>
                                          </div>
                                      </template>

                                      <template #right-icon>
                                          <div class="common_title_right" style="padding-top: 0.5rem;">
                                              <div class="common_trview" style="width: 0.666667rem; height: 0.666667rem;">
                                                  <img v-if="chidthrIsOpen('2')" src="../assets/imgs/arrow_icon_up.webp" alt="" />
                                                  <img v-else src="../assets/imgs/arrow_icon_down.webp" alt="" />
                                              </div>
                                          </div>
                                      </template>
                                      <div class="children_solid_v">
                                          <div class="children_solid"></div>
                                      </div>
                                      <div class="children_cont">
                                          <div class="children_cont_items">
                                              ¡Solicitar un préstamo en LaLANITAplus es súper fácil! Solo necesitas tener a la mano tu INE, tu número de teléfono y una cuenta bancaria válida donde puedas recibir tu dinero.
                                          </div>
                                      </div>
                                  </van-collapse-item>

                                  <van-collapse-item :border="hasborder" name="3">
                                      <template #title>
                                          <div class="children_title_wrap">
                                              <div class="children_title_left">
                                                  <div class="children_tleft_text">¿Cómo puedo solicitar un préstamo?</div>
                                              </div>
                                          </div>
                                      </template>

                                      <template #right-icon>
                                          <div class="common_title_right" style="padding-top: 0.5rem;">
                                              <div class="common_trview" style="width: 0.666667rem; height: 0.666667rem;">
                                                  <img v-if="chidthrIsOpen('3')" src="../assets/imgs/arrow_icon_up.webp" alt="" />
                                                  <img v-else src="../assets/imgs/arrow_icon_down.webp" alt="" />
                                              </div>
                                          </div>
                                      </template>
                                      <div class="children_solid_v">
                                          <div class="children_solid"></div>
                                      </div>
                                      <div class="children_cont">
                                          <div class="children_cont_items">
                                              Descarga LaLANITAplus desde la App Store o Google Play, regístrate con tu número de teléfono y completa la información necesaria para solicitar tu préstamo.
                                              <br/>¡No te preocupes! Tu información personal está segura con nosotros. Solo la utilizamos para evaluar tu límite de préstamo y, sin tu permiso, nunca compartimos tus datos con terceros. Puedes consultar nuestra declaración de privacidad en la aplicación o en la sección "¿Cómo protege LaLANITAplus mi privacidad?". ¡Tu seguridad es nuestra prioridad!
                                          </div>
                                      </div>
                                  </van-collapse-item>

                                  <van-collapse-item :border="hasborder" name="4">
                                      <template #title>
                                          <div class="children_title_wrap">
                                              <div class="children_title_left">
                                                  <div class="children_tleft_text">
                                                      ¿Cuánto tiempo tarda el proceso de aprobación del préstamo?
                                                  </div>
                                              </div>
                                          </div>
                                      </template>

                                      <template #right-icon>
                                          <div class="common_title_right" style="padding-top: 0.5rem;">
                                              <div class="common_trview" style="width: 0.666667rem; height: 0.666667rem;">
                                                  <img v-if="chidthrIsOpen('4')" src="../assets/imgs/arrow_icon_up.webp" alt="" />
                                                  <img v-else src="../assets/imgs/arrow_icon_down.webp" alt="" />
                                              </div>
                                          </div>
                                      </template>
                                      <div class="children_solid_v">
                                          <div class="children_solid"></div>
                                      </div>
                                      <div class="children_cont">
                                          <div class="children_cont_items">
                                              ¡En LaLANITAplus, queremos que tengas tu préstamo rápido! Una vez que completes toda tu información personal, la mayoría de las solicitudes se procesarán en solo 3 minutos. Si tu solicitud es aprobada, recibirás una notificación por SMS ✉️. Una vez que confirmes el desembolso, el dinero suele estar disponible en tu cuenta bancaria en aproximadamente 10 minutos.
                                              <br/>Recuerda que las transferencias bancarias pueden tener retrasos debido a problemas de red, ¡así que no te preocupes! Te enviaremos una notificación una vez que el pago sea exitoso. Generalmente, el dinero se acredita en tu cuenta dentro de las 24 horas. Si después de ese tiempo aún no lo has recibido, no dudes en contactar a nuestro servicio al cliente.
                                              <br/>Teléfono: 5585261054
                                          </div>
                                      </div>
                                  </van-collapse-item>

                                  <van-collapse-item :border="hasborder" name="5">
                                      <template #title>
                                          <div class="children_title_wrap">
                                              <div class="children_title_left">
                                                  <div class="children_tleft_text">¿Si el monto de préstamo que obtengo es menor al que necesito, ¿puedo solicitar un monto mayor?</div>
                                              </div>
                                          </div>
                                      </template>

                                      <template #right-icon>
                                          <div class="common_title_right" style="padding-top: 0.5rem;">
                                              <div class="common_trview" style="width: 0.666667rem; height: 0.666667rem;">
                                                  <img v-if="chidthrIsOpen('5')" src="../assets/imgs/arrow_icon_up.webp" alt="" />
                                                  <img v-else src="../assets/imgs/arrow_icon_down.webp" alt="" />
                                              </div>
                                          </div>
                                      </template>
                                      <div class="children_solid_v">
                                          <div class="children_solid"></div>
                                      </div>
                                      <div class="children_cont">
                                          <div class="children_cont_items">
                                              El monto de tu préstamo no puede ser inferior a tu límite de crédito. Te recomendamos que realices tus pagos a tiempo y mantengas un buen historial crediticio para que puedas acceder a mayores montos de préstamo.
                                          </div>
                                      </div>
                                  </van-collapse-item>

                                  <van-collapse-item :border="hasborder" name="6">
                                      <template #title>
                                          <div class="children_title_wrap">
                                              <div class="children_title_left">
                                                  <div class="children_tleft_text">
                                                      ¿Por qué se rechazó mi solicitud de préstamo?
                                                  </div>
                                              </div>
                                          </div>
                                      </template>

                                      <template #right-icon>
                                          <div class="common_title_right" style="padding-top: 0.5rem;">
                                              <div class="common_trview" style="width: 0.666667rem; height: 0.666667rem;">
                                                  <img v-if="chidthrIsOpen('6')" src="../assets/imgs/arrow_icon_up.webp" alt="" />
                                                  <img v-else src="../assets/imgs/arrow_icon_down.webp" alt="" />
                                              </div>
                                          </div>
                                      </template>
                                      <div class="children_solid_v">
                                          <div class="children_solid"></div>
                                      </div>
                                      <div class="children_cont">
                                          <div class="children_cont_items">
                                              En LaLANITAplus evaluamos periódicamente tu historial crediticio y ofrecemos límites de préstamo basados en tu historial. Por eso, es importante que realices tus pagos a tiempo y mantengas un buen historial para acceder a montos más altos.
                                              <br/>Si tu solicitud no fue aprobada, significa que no cumpliste con los requisitos necesarios para obtener un préstamo de LaLANITAplus. Pero no te preocupes; si más adelante cumples con los requisitos, recibirás un SMS de nuestra parte notificándote que puedes volver a solicitar. ¡Estamos aquí para ayudarte!
                                          </div>
                                      </div>
                                  </van-collapse-item>

                                  <van-collapse-item :border="hasborder" name="7">
                                      <template #title>
                                          <div class="children_title_wrap">
                                              <div class="children_title_left">
                                                  <div class="children_tleft_text">
                                                      ¿Si mi solicitud de préstamo fue rechazada, ¿puedo volver a solicitar?
                                                  </div>
                                              </div>
                                          </div>
                                      </template>

                                      <template #right-icon>
                                          <div class="common_title_right" style="padding-top: 0.5rem;">
                                              <div class="common_trview" style="width: 0.666667rem; height: 0.666667rem;">
                                                  <img v-if="chidthrIsOpen('7')" src="../assets/imgs/arrow_icon_up.webp" alt="" />
                                                  <img v-else src="../assets/imgs/arrow_icon_down.webp" alt="" />
                                              </div>
                                          </div>
                                      </template>
                                      <div class="children_solid_v">
                                          <div class="children_solid"></div>
                                      </div>
                                      <div class="children_cont">
                                          <div class="children_cont_items">
                                              ¡No te preocupes! En LaLANITAplus, evaluamos tu historial crediticio de manera regular y ajustamos tus límites de préstamo según tu historial. Te recomendamos realizar tus pagos a tiempo y mantener un buen historial. Si tu solicitud no fue aprobada, significa que no cumpliste con los requisitos para obtener un préstamo de LaLANITAplus. Pero si más adelante cumples con ellos, recibirás un SMS notificándote que puedes volver a aplicar.
                                          </div>
                                      </div>
                                  </van-collapse-item>

                                  <van-collapse-item :border="hasborder" name="8">
                                      <template #title>
                                          <div class="children_title_wrap">
                                              <div class="children_title_left">
                                                  <div class="children_tleft_text">
                                                      ¿Puedo solicitar un préstamo si no tengo trabajo?
                                                  </div>
                                              </div>
                                          </div>
                                      </template>

                                      <template #right-icon>
                                          <div class="common_title_right" style="padding-top: 0.5rem;">
                                              <div class="common_trview" style="width: 0.666667rem; height: 0.666667rem;">
                                                  <img v-if="chidthrIsOpen('8')" src="../assets/imgs/arrow_icon_up.webp" alt="" />
                                                  <img v-else src="../assets/imgs/arrow_icon_down.webp" alt="" />
                                              </div>
                                          </div>
                                      </template>
                                      <div class="children_solid_v">
                                          <div class="children_solid"></div>
                                      </div>
                                      <div class="children_cont">
                                          <div class="children_cont_items">
                                              ¡Claro que sí! Todos enfrentamos momentos difíciles. En LaLANITAplus, hacemos una evaluación integral de tu información personal para ofrecerte un límite de crédito. No rechazamos tu solicitud solo por no tener empleo. Solo asegúrate de que la información que proporciones sea verídica.
                                          </div>
                                      </div>
                                  </van-collapse-item>

                                  <van-collapse-item :border="hasborder" name="9">
                                      <template #title>
                                          <div class="children_title_wrap">
                                              <div class="children_title_left">
                                                  <div class="children_tleft_text">
                                                      ¿Afecta un documento de identidad caducado a mi solicitud de préstamo?
                                                  </div>
                                              </div>
                                          </div>
                                      </template>

                                      <template #right-icon>
                                          <div class="common_title_right" style="padding-top: 0.5rem;">
                                              <div class="common_trview" style="width: 0.666667rem; height: 0.666667rem;">
                                                  <img v-if="chidthrIsOpen('9')" src="../assets/imgs/arrow_icon_up.webp" alt="" />
                                                  <img v-else src="../assets/imgs/arrow_icon_down.webp" alt="" />
                                              </div>
                                          </div>
                                      </template>
                                      <div class="children_solid_v">
                                          <div class="children_solid"></div>
                                      </div>
                                      <div class="children_cont">
                                          <div class="children_cont_items">
                                              ¡Sí! Si tu identificación no está vigente, esto puede afectar tu solicitud de préstamo. Asegúrate de que tu identificación y la información de tu cuenta bancaria sean válidas antes de solicitar.
                                          </div>
                                      </div>
                                  </van-collapse-item>

                                  <van-collapse-item :border="hasborder" name="10">
                                      <template #title>
                                          <div class="children_title_wrap">
                                              <div class="children_title_left">
                                                  <div class="children_tleft_text">
                                                      ¿El monto del préstamo que solicito es el mismo que recibiré?
                                                  </div>
                                              </div>
                                          </div>
                                      </template>

                                      <template #right-icon>
                                          <div class="common_title_right" style="padding-top: 0.5rem;">
                                              <div class="common_trview" style="width: 0.666667rem; height: 0.666667rem;">
                                                  <img v-if="chidthrIsOpen('10')" src="../assets/imgs/arrow_icon_up.webp" alt="" />
                                                  <img v-else src="../assets/imgs/arrow_icon_down.webp" alt="" />
                                              </div>
                                          </div>
                                      </template>
                                      <div class="children_solid_v">
                                          <div class="children_solid"></div>
                                      </div>
                                      <div class="children_cont">
                                          <div class="children_cont_items">
                                              ¡Definitivamente! No descontamos ninguna tarifa al momento de tu solicitud. El monto total que solicitas se deposita directamente en la cuenta bancaria que proporcionaste, y la cantidad que recibes será la misma que solicitaste.
                                          </div>
                                      </div>
                                  </van-collapse-item>

                                  <van-collapse-item :border="hasborder" name="11">
                                      <template #title>
                                          <div class="children_title_wrap">
                                              <div class="children_title_left">
                                                  <div class="children_tleft_text">
                                                      ¿Por qué no ha llegado el préstamo a mi cuenta bancaria?
                                                  </div>
                                              </div>
                                          </div>
                                      </template>

                                      <template #right-icon>
                                          <div class="common_title_right" style="padding-top: 0.5rem;">
                                              <div class="common_trview" style="width: 0.666667rem; height: 0.666667rem;">
                                                  <img v-if="chidthrIsOpen('11')" src="../assets/imgs/arrow_icon_up.webp" alt="" />
                                                  <img v-else src="../assets/imgs/arrow_icon_down.webp" alt="" />
                                              </div>
                                          </div>
                                      </template>
                                      <div class="children_solid_v">
                                          <div class="children_solid"></div>
                                      </div>
                                      <div class="children_cont">
                                          <div class="children_cont_items">
                                              Asegúrate de que tu solicitud haya sido aprobada y verifica que la información de tu cuenta bancaria sea correcta y esté activa. Recuerda que las transferencias pueden tardar un poco más por problemas de red, así que mantén la calma. Te enviaremos una notificación tan pronto como el pago sea exitoso. Generalmente, el dinero se acredita en tu cuenta en menos de 24 horas. Si después de este tiempo no lo has recibido, contacta a nuestro servicio al cliente.
                                              <br/>Teléfono: 5585261054
                                          </div>
                                      </div>
                                  </van-collapse-item>

                                  <van-collapse-item :border="hasborder" name="12">
                                      <template #title>
                                          <div class="children_title_wrap">
                                              <div class="children_title_left">
                                                  <div class="children_tleft_text">
                                                      Mi solicitud de préstamo ha sido aprobada, pero la aplicación dice 'Depositando' por más de 24 horas. ¿Qué debo hacer?
                                                  </div>
                                              </div>
                                          </div>
                                      </template>

                                      <template #right-icon>
                                          <div class="common_title_right" style="padding-top: 0.5rem;">
                                              <div class="common_trview" style="width: 0.666667rem; height: 0.666667rem;">
                                                  <img v-if="chidthrIsOpen('12')" src="../assets/imgs/arrow_icon_up.webp" alt="" />
                                                  <img v-else src="../assets/imgs/arrow_icon_down.webp" alt="" />
                                              </div>
                                          </div>
                                      </template>
                                      <div class="children_solid_v">
                                          <div class="children_solid"></div>
                                      </div>
                                      <div class="children_cont">
                                          <div class="children_cont_items">
                                              No se preocupe si encuentra este tipo de problema. Llame a nuestro número de servicio al cliente lo antes posible y proporcione la información de su pedido. Resolveremos su problema de préstamo dentro de las 24 horas.
                                          </div>
                                      </div>
                                  </van-collapse-item>

                                  <van-collapse-item :border="hasborder" name="13">
                                      <template #title>
                                          <div class="children_title_wrap">
                                              <div class="children_title_left">
                                                  <div class="children_tleft_text">
                                                      ¿Mi solicitud de préstamo ha sido aprobada, pero no he recibido el dinero ¿Qué debo hacer?
                                                  </div>
                                              </div>
                                          </div>
                                      </template>

                                      <template #right-icon>
                                          <div class="common_title_right" style="padding-top: 0.5rem;">
                                              <div class="common_trview" style="width: 0.666667rem; height: 0.666667rem;">
                                                  <img v-if="chidthrIsOpen('13')" src="../assets/imgs/arrow_icon_up.webp" alt="" />
                                                  <img v-else src="../assets/imgs/arrow_icon_down.webp" alt="" />
                                              </div>
                                          </div>
                                      </template>
                                      <div class="children_solid_v">
                                          <div class="children_solid"></div>
                                      </div>
                                      <div class="children_cont">
                                          <div class="children_cont_items">
                                              No se preocupe si encuentra este tipo de problema. Llame a nuestro número de servicio al cliente lo antes posible y proporcione la información de su pedido. Resolveremos su problema de préstamo dentro de las 24 horas.
                                          </div>
                                      </div>
                                  </van-collapse-item>

                              </van-collapse>
                          </div>

                      </van-tab>
                      <van-tab title="Preguntas de pago">
                          <div class="common_children_wrap">
                              <div class="common_children_title">Cuestion de pago</div>
                              <van-collapse :border="hasborder" v-model="chidtwo_Names">
                                  <van-collapse-item :border="hasborder" name="1">
                                      <template #title>
                                          <div class="children_title_wrap">
                                              <div class="children_title_left">
                                                  <div class="children_tleft_text">¿Cuáles son las formas de realizar mi pago?</div>
                                              </div>
                                          </div>
                                      </template>

                                      <template #right-icon>
                                          <div class="common_title_right" style="padding-top: 0.5rem;">
                                              <div class="common_trview" style="width: 0.666667rem; height: 0.666667rem;">
                                                  <img v-if="chidtwoIsOpen('1')" src="../assets/imgs/arrow_icon_up.webp" alt="" />
                                                  <img v-else src="../assets/imgs/arrow_icon_down.webp" alt="" />
                                              </div>
                                          </div>
                                      </template>
                                      <div class="children_solid_v">
                                          <div class="children_solid"></div>
                                      </div>
                                      <div class="children_cont">
                                          <div class="children_cont_items">¡Pagar es muy fácil! Puedes hacerlo a través de un código de pago en línea. Solo sigue estos sencillos pasos:</div>
                                          <div class="children_cont_items">
                                              ① Copia el cuenta de pago en la interfaz de pago de la app.
                                          </div>
                                          <div class="children_cont_items">
                                              ② Abre tu aplicación de pago de terceros y completa la siguiente información:Banco、Destinatario de la transferencia、Concepto
                                          </div>
                                      </div>
                                  </van-collapse-item>

                                  <van-collapse-item :border="hasborder" name="2">
                                      <template #title>
                                          <div class="children_title_wrap">
                                              <div class="children_title_left">
                                                  <div class="children_tleft_text">¿Dónde puedo ver la fecha de mi pago? </div>
                                              </div>
                                          </div>
                                      </template>

                                      <template #right-icon>
                                          <div class="common_title_right" style="padding-top: 0.5rem;">
                                              <div class="common_trview" style="width: 0.666667rem; height: 0.666667rem;">
                                                  <img v-if="chidtwoIsOpen('2')" src="../assets/imgs/arrow_icon_up.webp" alt="" />
                                                  <img v-else src="../assets/imgs/arrow_icon_down.webp" alt="" />
                                              </div>
                                          </div>
                                      </template>
                                      <div class="children_solid_v">
                                          <div class="children_solid"></div>
                                      </div>
                                      <div class="children_cont">
                                          <div class="children_cont_items">
                                              Una vez que tu solicitud de préstamo haya sido aprobada, podrás ver la fecha de tu pago en la página de pago de la app.
                                          </div>
                                      </div>
                                  </van-collapse-item>

                                  <van-collapse-item :border="hasborder" name="3">
                                      <template #title>
                                          <div class="children_title_wrap">
                                              <div class="children_title_left">
                                                  <div class="children_tleft_text">¿Puedo hacer pagos en cuotas?</div>
                                              </div>
                                          </div>
                                      </template>

                                      <template #right-icon>
                                          <div class="common_title_right" style="padding-top: 0.5rem;">
                                              <div class="common_trview" style="width: 0.666667rem; height: 0.666667rem;">
                                                  <img v-if="chidtwoIsOpen('3')" src="../assets/imgs/arrow_icon_up.webp" alt="" />
                                                  <img v-else src="../assets/imgs/arrow_icon_down.webp" alt="" />
                                              </div>
                                          </div>
                                      </template>
                                      <div class="children_solid_v">
                                          <div class="children_solid"></div>
                                      </div>
                                      <div class="children_cont">
                                          <div class="children_cont_items">
                                              ¡Claro que sí! Para ayudarte a manejar mejor tus pagos, en LaLANITAplus apoyamos el reembolso en cuotas. Puedes optar por planes de pago que van de 91 a 180 días.
                                          </div>
                                      </div>
                                  </van-collapse-item>

                                  <van-collapse-item :border="hasborder" name="4">
                                      <template #title>
                                          <div class="children_title_wrap">
                                              <div class="children_title_left">
                                                  <div class="children_tleft_text">¿Puedo pagar mi préstamo antes de tiempo?</div>
                                              </div>
                                          </div>
                                      </template>

                                      <template #right-icon>
                                          <div class="common_title_right" style="padding-top: 0.5rem;">
                                              <div class="common_trview" style="width: 0.666667rem; height: 0.666667rem;">
                                                  <img v-if="chidtwoIsOpen('4')" src="../assets/imgs/arrow_icon_up.webp" alt="" />
                                                  <img v-else src="../assets/imgs/arrow_icon_down.webp" alt="" />
                                              </div>
                                          </div>
                                      </template>
                                      <div class="children_solid_v">
                                          <div class="children_solid"></div>
                                      </div>
                                      <div class="children_cont">
                                          <div class="children_cont_items">
                                              ¡Por supuesto! En LaLANITAplus, animamos a nuestros usuarios a que paguen sus préstamos anticipadamente. Hacerlo no solo reduce los intereses que pagas, ¡sino que también te ayuda a acumular más crédito para tu próximo préstamo!
                                          </div>
                                      </div>
                                  </van-collapse-item>

                                  <van-collapse-item :border="hasborder" name="5">
                                      <template #title>
                                          <div class="children_title_wrap">
                                              <div class="children_title_left">
                                                  <div class="children_tleft_text">¿Qué pasa si no puedo pagar mi préstamo a tiempo?</div>
                                              </div>
                                          </div>
                                      </template>

                                      <template #right-icon>
                                          <div class="common_title_right" style="padding-top: 0.5rem;">
                                              <div class="common_trview" style="width: 0.666667rem; height: 0.666667rem;">
                                                  <img v-if="chidtwoIsOpen('5')" src="../assets/imgs/arrow_icon_up.webp" alt="" />
                                                  <img v-else src="../assets/imgs/arrow_icon_down.webp" alt="" />
                                              </div>
                                          </div>
                                      </template>
                                      <div class="children_solid_v">
                                          <div class="children_solid"></div>
                                      </div>
                                      <div class="children_cont">
                                          <div class="children_cont_items">
                                              Si no realizas tu pago a tiempo, aplicaremos una penalización por demora con intereses después de la fecha de vencimiento. Para evitar estos cargos, te recomendamos pagar tu préstamo lo antes posible. Recuerda que si no pagas a tiempo, también afectará tu historial crediticio con LaLANITAplus, disminuyendo tus límites para futuros préstamos.
                                          </div>
                                      </div>
                                  </van-collapse-item>

                                  <van-collapse-item :border="hasborder" name="6">
                                      <template #title>
                                          <div class="children_title_wrap">
                                              <div class="children_title_left">
                                                  <div class="children_tleft_text">Si me retraso en el pago, ¿será contactado por un representante?</div>
                                              </div>
                                          </div>
                                      </template>

                                      <template #right-icon>
                                          <div class="common_title_right" style="padding-top: 0.5rem;">
                                              <div class="common_trview" style="width: 0.666667rem; height: 0.666667rem;">
                                                  <img v-if="chidtwoIsOpen('6')" src="../assets/imgs/arrow_icon_up.webp" alt="" />
                                                  <img v-else src="../assets/imgs/arrow_icon_down.webp" alt="" />
                                              </div>
                                          </div>
                                      </template>
                                      <div class="children_solid_v">
                                          <div class="children_solid"></div>
                                      </div>
                                      <div class="children_cont">
                                          <div class="children_cont_items">
                                              Si no realizas tu pago a tiempo, nuestro equipo de cobranza se pondrá en contacto contigo para ofrecerte soluciones. ¡Pero cuidado! Asegúrate de verificar la información del contacto para evitar fraudes.
                                          </div>
                                      </div>
                                  </van-collapse-item>

                                  <van-collapse-item :border="hasborder" name="7">
                                      <template #title>
                                          <div class="children_title_wrap">
                                              <div class="children_title_left">
                                                  <div class="children_tleft_text">¿Qué hago si accidentalmente pago de más?</div>
                                              </div>
                                          </div>
                                      </template>

                                      <template #right-icon>
                                          <div class="common_title_right" style="padding-top: 0.5rem;">
                                              <div class="common_trview" style="width: 0.666667rem; height: 0.666667rem;">
                                                  <img v-if="chidtwoIsOpen('7')" src="../assets/imgs/arrow_icon_up.webp" alt="" />
                                                  <img v-else src="../assets/imgs/arrow_icon_down.webp" alt="" />
                                              </div>
                                          </div>
                                      </template>
                                      <div class="children_solid_v">
                                          <div class="children_solid"></div>
                                      </div>
                                      <div class="children_cont">
                                          <div class="children_cont_items">
                                              ¡No te preocupes! Si por error realizas un pago mayor a la cantidad adeudada, te devolveremos el monto extra. Solo contáctanos de inmediato y estaremos encantados de ayudarte .
                                              <br/>Teléfono: 5585261054
                                          </div>
                                      </div>
                                  </van-collapse-item>

                                  <van-collapse-item :border="hasborder" name="8">
                                      <template #title>
                                          <div class="children_title_wrap">
                                              <div class="children_title_left">
                                                  <div class="children_tleft_text">He pagado, pero la aplicación todavía muestra que hay pedidos que no se han liquidado ¿Qué debo hacer?</div>
                                              </div>
                                          </div>
                                      </template>

                                      <template #right-icon>
                                          <div class="common_title_right" style="padding-top: 0.5rem;">
                                              <div class="common_trview" style="width: 0.666667rem; height: 0.666667rem;">
                                                  <img v-if="chidtwoIsOpen('8')" src="../assets/imgs/arrow_icon_up.webp" alt="" />
                                                  <img v-else src="../assets/imgs/arrow_icon_down.webp" alt="" />
                                              </div>
                                          </div>
                                      </template>
                                      <div class="children_solid_v">
                                          <div class="children_solid"></div>
                                      </div>
                                      <div class="children_cont">
                                          <div class="children_cont_items">
                                              No se preocupe si encuentra este tipo de problema. Llame a nuestro número de servicio al cliente lo antes posible y proporcione su información de pago. Resolveremos su problema de pago dentro de las 24 horas.
                                          </div>
                                      </div>
                                  </van-collapse-item>
                              </van-collapse>
                          </div>
                      </van-tab>
                      <van-tab title="Preguntas de la App">
                          <div class="common_children_wrap">
                              <div class="common_children_title">Sobre Nosotros</div>
                              <van-collapse :border="hasborder" v-model="chidone_Names">
                                  <van-collapse-item :border="hasborder" name="1">
                                      <template #title>
                                          <div class="children_title_wrap">
                                              <div class="children_title_left">
                                                  <div class="children_tleft_text">¿Qué es LaLANITAplus? </div>
                                              </div>
                                          </div>
                                      </template>

                                      <template #right-icon>
                                          <div class="common_title_right" style="padding-top: 0.5rem;">
                                              <div class="common_trview" style="width: 0.666667rem; height: 0.666667rem;">
                                                  <img v-if="chidoneIsOpen('1')" src="../assets/imgs/arrow_icon_up.webp" alt="" />
                                                  <img v-else src="../assets/imgs/arrow_icon_down.webp" alt="" />
                                              </div>
                                          </div>
                                      </template>
                                      <div class="children_solid_v">
                                          <div class="children_solid"></div>
                                      </div>
                                      <div class="children_cont">
                                          <div class="children_cont_items">
                                              LaLANITAplus es una plataforma segura y confiable para solicitar préstamos en línea. A través de nuestra app disponible para Android e iOS, ofrecemos préstamos inmediatos desde xx pesos hasta xx pesos. ¡El proceso es sencillo, rápido y seguro! Solo completa los datos personales y podrás ver el monto que puedes solicitar, el plazo de pago y la tasa de interés.
                                          </div>
                                          <div class="children_cont_items">Además, somos una empresa financiera registrada y regulada por CONDUSEF, ¡así que puedes estar tranquilo! Tu privacidad y seguridad son nuestra prioridad, y no tienes que preocuparte por la seguridad de tu información personal ni por fraude. Estamos a tu disposición 24/7, los 365 días del año. Si en algún momento necesitas ayuda, no dudes en contactarnos:</div>
                                          <div class="children_cont_items">Correo: servicioplus@lalanitaplus.com</div>
                                          <div class="children_cont_items">Teléfono: 5585261054</div>
                                          <div class="children_cont_items">Whatsapp: 7204712755</div>
                                          <div class="children_cont_items">¡Descarga nuestra app y comienza a disfrutar de una experiencia financiera única! </div>
                                      </div>
                                  </van-collapse-item>

                                  <van-collapse-item :border="hasborder" name="2">
                                      <template #title>
                                          <div class="children_title_wrap">
                                              <div class="children_title_left">
                                                  <div class="children_tleft_text">
                                                      ¿LaLANITAplus es segura?
                                                  </div>
                                              </div>
                                          </div>
                                      </template>

                                      <template #right-icon>
                                          <div class="common_title_right" style="padding-top: 0.5rem;">
                                              <div class="common_trview" style="width: 0.666667rem; height: 0.666667rem;">
                                                  <img v-if="chidoneIsOpen('2')" src="../assets/imgs/arrow_icon_up.webp" alt="" />
                                                  <img v-else src="../assets/imgs/arrow_icon_down.webp" alt="" />
                                              </div>
                                          </div>
                                      </template>
                                      <div class="children_solid_v">
                                          <div class="children_solid"></div>
                                      </div>
                                      <div class="children_cont">
                                          <div class="children_cont_items">
                                              ¡Claro que sí! Somos una SOFOM (Sociedad Financiera de Objeto Múltiple) registrada en la Comisión Nacional Bancaria y de Valores (CNBV). Además, la Comisión Nacional para la Protección y Defensa de los Usuarios de Servicios Financieros (CONDUSEF) supervisa nuestras operaciones para garantizar que cumplamos con la transparencia y regulación de los servicios financieros.
                                              <br/>
                                              No te preocupes por la seguridad de tus datos personales. Sin tu consentimiento, no compartimos tu información con terceros y la protegemos de acuerdo con nuestra política de privacidad.
                                              <br/>
                                              Por lo tanto, puede estar seguro de solicitar un préstamo con LaLANITAplus.
                                          </div>
                                      </div>
                                  </van-collapse-item>

                                  <van-collapse-item :border="hasborder" name="3">
                                      <template #title>
                                          <div class="children_title_wrap">
                                              <div class="children_title_left">
                                                  <div class="children_tleft_text">
                                                      ¿Cuál es el límite mínimo y máximo de préstamo que puedo obtener en LaLANITAplus?
                                                  </div>
                                              </div>
                                          </div>
                                      </template>

                                      <template #right-icon>
                                          <div class="common_title_right" style="padding-top: 0.5rem;">
                                              <div class="common_trview" style="width: 0.666667rem; height: 0.666667rem;">
                                                  <img v-if="chidoneIsOpen('3')" src="../assets/imgs/arrow_icon_up.webp" alt="" />
                                                  <img v-else src="../assets/imgs/arrow_icon_down.webp" alt="" />
                                              </div>
                                          </div>
                                      </template>
                                      <div class="children_solid_v">
                                          <div class="children_solid"></div>
                                      </div>
                                      <div class="children_cont">
                                          <div class="children_cont_items">
                                              En LaLANITAplus, puedes obtener préstamos de hasta <span style="font-weight: bold;">20,000</span> pesos. El monto otorgado se evalúa automáticamente según la información personal que proporcionas al momento de la solicitud. ¡Solicita ahora y descubre lo que podemos ofrecerte!
                                          </div>
                                      </div>
                                  </van-collapse-item>

                                  <van-collapse-item :border="hasborder" name="4">
                                      <template #title>
                                          <div class="children_title_wrap">
                                              <div class="children_title_left">
                                                  <div class="children_tleft_text">¿Cómo puedo mejorar mi monto de préstamo en LaLANITAplus?</div>
                                              </div>
                                          </div>
                                      </template>

                                      <template #right-icon>
                                          <div class="common_title_right" style="padding-top: 0.5rem;">
                                              <div class="common_trview" style="width: 0.666667rem; height: 0.666667rem;">
                                                  <img v-if="chidoneIsOpen('4')" src="../assets/imgs/arrow_icon_up.webp" alt="" />
                                                  <img v-else src="../assets/imgs/arrow_icon_down.webp" alt="" />
                                              </div>
                                          </div>
                                      </template>
                                      <div class="children_solid_v">
                                          <div class="children_solid"></div>
                                      </div>
                                      <div class="children_cont">
                                          <div class="children_cont_items">
                                              En LaLANITAplus, evaluamos periódicamente tu historial crediticio y ofrecemos montos de préstamo basados en tu calificación. ¡Asegúrate de realizar tus pagos a tiempo para aumentar tu capacidad de préstamo! Si pides préstamos con frecuencia y mantienes un buen historial de pagos, tendrás la oportunidad de acceder a montos más altos. ¡Haz que tu confianza se convierten en mayores oportunidades!
                                          </div>
                                      </div>
                                  </van-collapse-item>

                                  <van-collapse-item :border="hasborder" name="5">
                                      <template #title>
                                          <div class="children_title_wrap">
                                              <div class="children_title_left">
                                                  <div class="children_tleft_text">¿Cuál es la tasa de interés en LaLANITAplus?</div>
                                              </div>
                                          </div>
                                      </template>

                                      <template #right-icon>
                                          <div class="common_title_right" style="padding-top: 0.5rem;">
                                              <div class="common_trview" style="width: 0.666667rem; height: 0.666667rem;">
                                                  <img v-if="chidoneIsOpen('5')" src="../assets/imgs/arrow_icon_up.webp" alt="" />
                                                  <img v-else src="../assets/imgs/arrow_icon_down.webp" alt="" />
                                              </div>
                                          </div>
                                      </template>
                                      <div class="children_solid_v">
                                          <div class="children_solid"></div>
                                      </div>
                                      <div class="children_cont">
                                          <div class="children_cont_items">
                                              La tasa de interés en LaLANITAplus se ajusta según tu plan de préstamo, comenzando desde una increíble tasa diaria del <span style="font-weight: bold;">0.09</span>%. Si quieres conocer tasas específicas, realiza una simulación en nuestra página de solicitud de préstamo. ¡Aprovecha nuestras tasas más competitivas!
                                          </div>
                                      </div>
                                  </van-collapse-item>

                                  <van-collapse-item :border="hasborder" name="6">
                                      <template #title>
                                          <div class="children_title_wrap">
                                              <div class="children_title_left">
                                                  <div class="children_tleft_text">¿Hay descuentos en la tasa de interés si realizo múltiples préstamos?</div>
                                              </div>
                                          </div>
                                      </template>

                                      <template #right-icon>
                                          <div class="common_title_right" style="padding-top: 0.5rem;">
                                              <div class="common_trview" style="width: 0.666667rem; height: 0.666667rem;">
                                                  <img v-if="chidoneIsOpen('6')" src="../assets/imgs/arrow_icon_up.webp" alt="" />
                                                  <img v-else src="../assets/imgs/arrow_icon_down.webp" alt="" />
                                              </div>
                                          </div>
                                      </template>
                                      <div class="children_solid_v">
                                          <div class="children_solid"></div>
                                      </div>
                                      <div class="children_cont">
                                          <div class="children_cont_items">
                                              La tasa de interés depende únicamente del monto del préstamo y el período de pago, pero ¡tenemos sorpresas para ti! De vez en cuando, organizamos actividades especiales y otorgamos diferentes tipos de regalos o cupones que permiten disfrutar los descuentos en tus intereses. ¡No te lo pierdas!
                                          </div>
                                      </div>
                                  </van-collapse-item>

                                  <van-collapse-item :border="hasborder" name="7">
                                      <template #title>
                                          <div class="children_title_wrap">
                                              <div class="children_title_left">
                                                  <div class="children_tleft_text">¿Qué debo hacer si robaron o perdi mi teléfono ?</div>
                                              </div>
                                          </div>
                                      </template>

                                      <template #right-icon>
                                          <div class="common_title_right" style="padding-top: 0.5rem;">
                                              <div class="common_trview" style="width: 0.666667rem; height: 0.666667rem;">
                                                  <img v-if="chidoneIsOpen('7')" src="../assets/imgs/arrow_icon_up.webp" alt="" />
                                                  <img v-else src="../assets/imgs/arrow_icon_down.webp" alt="" />
                                              </div>
                                          </div>
                                      </template>
                                      <div class="children_solid_v">
                                          <div class="children_solid"></div>
                                      </div>
                                      <div class="children_cont">
                                          <div class="children_cont_items">
                                              ¡No te preocupes! Si robaron o perdiste tu teléfono, puedes contactar a nuestro servicio al cliente para cancelar tu cuenta original de inmediato.
                                          </div>
                                          <div class="children_cont_items">
                                              Email: servicioplus@lalanitaplus.com
                                          </div>
                                          <div class="children_cont_items">
                                              Teléfono: 5585261054
                                          </div>
                                          <div class="children_cont_items">
                                              Whatsapp: 7204712755
                                          </div>
                                      </div>
                                  </van-collapse-item>

                                  <van-collapse-item :border="hasborder" name="8">
                                      <template #title>
                                          <div class="children_title_wrap">
                                              <div class="children_title_left">
                                                  <div class="children_tleft_text">¿Cómo puedo verificar si un correo electrónico, mensaje o llamada sospechosos de fraudes son de LaLANITAplus?</div>
                                              </div>
                                          </div>
                                      </template>

                                      <template #right-icon>
                                          <div class="common_title_right" style="padding-top: 0.5rem;">
                                              <div class="common_trview" style="width: 0.666667rem; height: 0.666667rem;">
                                                  <img v-if="chidoneIsOpen('8')" src="../assets/imgs/arrow_icon_up.webp" alt="" />
                                                  <img v-else src="../assets/imgs/arrow_icon_down.webp" alt="" />
                                              </div>
                                          </div>
                                      </template>
                                      <div class="children_solid_v">
                                          <div class="children_solid"></div>
                                      </div>
                                      <div class="children_cont">
                                          <div class="children_cont_items">
                                              ¡Nunca enviamos información a través de canales no oficiales!
                                          </div>
                                          <div class="children_cont_items">
                                              Si no estás seguro de haber recibido un correo electrónico, mensaje o llamada fraudulenta, puedes contactarnos para verificar. Aquí tienes nuestros datos oficiales:
                                          </div>
                                          <div class="children_cont_items">
                                              Email: servicioplus@lalanitaplus.com
                                          </div>
                                          <div class="children_cont_items">
                                              Teléfono: 5585261054
                                          </div>
                                          <div class="children_cont_items">
                                              Whatsapp: 7204712755
                                          </div>
                                      </div>
                                  </van-collapse-item>

                                  <van-collapse-item :border="hasborder" name="9">
                                      <template #title>
                                          <div class="children_title_wrap">
                                              <div class="children_title_left">
                                                  <div class="children_tleft_text">¿Cómo puedo reportar fraude?</div>
                                              </div>
                                          </div>
                                      </template>

                                      <template #right-icon>
                                          <div class="common_title_right" style="padding-top: 0.5rem;">
                                              <div class="common_trview" style="width: 0.666667rem; height: 0.666667rem;">
                                                  <img v-if="chidoneIsOpen('9')" src="../assets/imgs/arrow_icon_up.webp" alt="" />
                                                  <img v-else src="../assets/imgs/arrow_icon_down.webp" alt="" />
                                              </div>
                                          </div>
                                      </template>
                                      <div class="children_solid_v">
                                          <div class="children_solid"></div>
                                      </div>
                                      <div class="children_cont">
                                          <div class="children_cont_items">
                                              Si recibes un correo electrónico, mensaje o llamada sospechosos, puedes reportarlos a nuestro servicio al cliente. ¡Te animamos a que nos ayudes a combatir el fraude! Si la información que proporcionas resulta ser válida, recompensamos con un regalo o un cupón, ¡como agradecimiento!
                                          </div>
                                          <div class="children_cont_items">
                                              Nuestros datos de contacto:
                                          </div>
                                          <div class="children_cont_items">
                                              Email: servicioplus@lalanitaplus.com
                                          </div>
                                          <div class="children_cont_items">
                                              Teléfono: 5585261054
                                          </div>
                                          <div class="children_cont_items">
                                              Whatsapp: 7204712755
                                          </div>
                                      </div>
                                  </van-collapse-item>
                              </van-collapse>
                          </div>
                      </van-tab>
                  </van-tabs>
              </div>
          </div>
      </div>

    </div>
    <footPage></footPage>
  </div>
  <div v-else class="mobile_viewrap">
      <div class="mobile_wrap">
          <mobNav :activeNav="activeNav"></mobNav>
      </div>
      <div style="width: 100%; height: 100px;"></div>
      <div id="lalanitasobre_mobile" class="common_problem_wrap">
          <div id="common_problem_tabs" class="common_problem_tab">
              <van-tabs type="card">
                  <van-tab title="Preguntas de solicitud">
                      <div class="common_children_wrap">
                          <div class="common_children_title">Cuestiones de préstamo</div>
                          <van-collapse :border="hasborder" v-model="chidthr_Names">
                              <van-collapse-item :border="hasborder" name="1">
                                  <template #title>
                                      <div class="children_title_wrap">
                                          <div class="children_title_left">
                                              <div class="children_tleft_text">¿Cuáles son los requisitos para solicitar un préstamo?</div>
                                          </div>
                                      </div>
                                  </template>

                                  <template #right-icon>
                                      <div class="common_title_right" style="padding-top: 0.5rem;">
                                          <div class="common_trview" style="width: 0.666667rem; height: 0.666667rem;">
                                              <img v-if="chidthrIsOpen('1')" src="../assets/imgs/arrow_icon_up.webp" alt="" />
                                              <img v-else src="../assets/imgs/arrow_icon_down.webp" alt="" />
                                          </div>
                                      </div>
                                  </template>

                                  <div class="children_cont">
                                      <div class="children_cont_items">
                                          Para solicitar un préstamo en LaLANITAplus, necesitas cumplir con lo siguiente:
                                          <br/> Ser ciudadano mexicano mayor de 18 años.
                                          <br/> Tener una cuenta bancaria en México.
                                          <br/> Estar dentro del territorio mexicano y contar con tu identificación oficial mexicana.
                                          <br/> La solicitud de préstamo debe ser realizada por ti mismo.
                                          Si no cumples con estos requisitos, tu solicitud de préstamo no podrá ser aprobada.
                                          No requerimos ningún tipo de pago anticipado. Solo necesitas registrarte con tu número de teléfono, completar tu información personal y enviar tu solicitud de préstamo; ¡todo el proceso es completamente gratuito!
                                      </div>
                                  </div>
                              </van-collapse-item>

                              <van-collapse-item :border="hasborder" name="2">
                                  <template #title>
                                      <div class="children_title_wrap">
                                          <div class="children_title_left">
                                              <div class="children_tleft_text">¿Qué documentos necesito para solicitar un préstamo?</div>
                                          </div>
                                      </div>
                                  </template>

                                  <template #right-icon>
                                      <div class="common_title_right" style="padding-top: 0.5rem;">
                                          <div class="common_trview" style="width: 0.666667rem; height: 0.666667rem;">
                                              <img v-if="chidthrIsOpen('2')" src="../assets/imgs/arrow_icon_up.webp" alt="" />
                                              <img v-else src="../assets/imgs/arrow_icon_down.webp" alt="" />
                                          </div>
                                      </div>
                                  </template>

                                  <div class="children_cont">
                                      <div class="children_cont_items">
                                          ¡Solicitar un préstamo en LaLANITAplus es súper fácil! Solo necesitas tener a la mano tu INE, tu número de teléfono y una cuenta bancaria válida donde puedas recibir tu dinero.
                                      </div>
                                  </div>
                              </van-collapse-item>

                              <van-collapse-item :border="hasborder" name="3">
                                  <template #title>
                                      <div class="children_title_wrap">
                                          <div class="children_title_left">
                                              <div class="children_tleft_text">¿Cómo puedo solicitar un préstamo?</div>
                                          </div>
                                      </div>
                                  </template>

                                  <template #right-icon>
                                      <div class="common_title_right" style="padding-top: 0.5rem;">
                                          <div class="common_trview" style="width: 0.666667rem; height: 0.666667rem;">
                                              <img v-if="chidthrIsOpen('3')" src="../assets/imgs/arrow_icon_up.webp" alt="" />
                                              <img v-else src="../assets/imgs/arrow_icon_down.webp" alt="" />
                                          </div>
                                      </div>
                                  </template>

                                  <div class="children_cont">
                                      <div class="children_cont_items">
                                          Descarga LaLANITAplus desde la App Store o Google Play, regístrate con tu número de teléfono y completa la información necesaria para solicitar tu préstamo.
                                          <br/>¡No te preocupes! Tu información personal está segura con nosotros. Solo la utilizamos para evaluar tu límite de préstamo y, sin tu permiso, nunca compartimos tus datos con terceros. Puedes consultar nuestra declaración de privacidad en la aplicación o en la sección "¿Cómo protege LaLANITAplus mi privacidad?". ¡Tu seguridad es nuestra prioridad!
                                      </div>
                                  </div>
                              </van-collapse-item>

                              <van-collapse-item :border="hasborder" name="4">
                                  <template #title>
                                      <div class="children_title_wrap">
                                          <div class="children_title_left">
                                              <div class="children_tleft_text">
                                                  ¿Cuánto tiempo tarda el proceso de aprobación del préstamo?
                                              </div>
                                          </div>
                                      </div>
                                  </template>

                                  <template #right-icon>
                                      <div class="common_title_right" style="padding-top: 0.5rem;">
                                          <div class="common_trview" style="width: 0.666667rem; height: 0.666667rem;">
                                              <img v-if="chidthrIsOpen('4')" src="../assets/imgs/arrow_icon_up.webp" alt="" />
                                              <img v-else src="../assets/imgs/arrow_icon_down.webp" alt="" />
                                          </div>
                                      </div>
                                  </template>

                                  <div class="children_cont">
                                      <div class="children_cont_items">
                                          ¡En LaLANITAplus, queremos que tengas tu préstamo rápido! Una vez que completes toda tu información personal, la mayoría de las solicitudes se procesarán en solo 3 minutos. Si tu solicitud es aprobada, recibirás una notificación por SMS ✉️. Una vez que confirmes el desembolso, el dinero suele estar disponible en tu cuenta bancaria en aproximadamente 10 minutos.
                                          <br/>Recuerda que las transferencias bancarias pueden tener retrasos debido a problemas de red, ¡así que no te preocupes! Te enviaremos una notificación una vez que el pago sea exitoso. Generalmente, el dinero se acredita en tu cuenta dentro de las 24 horas. Si después de ese tiempo aún no lo has recibido, no dudes en contactar a nuestro servicio al cliente.
                                          <br/>Teléfono: 5585261054
                                      </div>
                                  </div>
                              </van-collapse-item>

                              <van-collapse-item :border="hasborder" name="5">
                                  <template #title>
                                      <div class="children_title_wrap">
                                          <div class="children_title_left">
                                              <div class="children_tleft_text">¿Si el monto de préstamo que obtengo es menor al que necesito, ¿puedo solicitar un monto mayor?</div>
                                          </div>
                                      </div>
                                  </template>

                                  <template #right-icon>
                                      <div class="common_title_right" style="padding-top: 0.5rem;">
                                          <div class="common_trview" style="width: 0.666667rem; height: 0.666667rem;">
                                              <img v-if="chidthrIsOpen('5')" src="../assets/imgs/arrow_icon_up.webp" alt="" />
                                              <img v-else src="../assets/imgs/arrow_icon_down.webp" alt="" />
                                          </div>
                                      </div>
                                  </template>

                                  <div class="children_cont">
                                      <div class="children_cont_items">
                                          El monto de tu préstamo no puede ser inferior a tu límite de crédito. Te recomendamos que realices tus pagos a tiempo y mantengas un buen historial crediticio para que puedas acceder a mayores montos de préstamo.
                                      </div>
                                  </div>
                              </van-collapse-item>

                              <van-collapse-item :border="hasborder" name="6">
                                  <template #title>
                                      <div class="children_title_wrap">
                                          <div class="children_title_left">
                                              <div class="children_tleft_text">
                                                  ¿Por qué se rechazó mi solicitud de préstamo?
                                              </div>
                                          </div>
                                      </div>
                                  </template>

                                  <template #right-icon>
                                      <div class="common_title_right" style="padding-top: 0.5rem;">
                                          <div class="common_trview" style="width: 0.666667rem; height: 0.666667rem;">
                                              <img v-if="chidthrIsOpen('6')" src="../assets/imgs/arrow_icon_up.webp" alt="" />
                                              <img v-else src="../assets/imgs/arrow_icon_down.webp" alt="" />
                                          </div>
                                      </div>
                                  </template>

                                  <div class="children_cont">
                                      <div class="children_cont_items">
                                          En LaLANITAplus evaluamos periódicamente tu historial crediticio y ofrecemos límites de préstamo basados en tu historial. Por eso, es importante que realices tus pagos a tiempo y mantengas un buen historial para acceder a montos más altos.
                                          <br/>Si tu solicitud no fue aprobada, significa que no cumpliste con los requisitos necesarios para obtener un préstamo de LaLANITAplus. Pero no te preocupes; si más adelante cumples con los requisitos, recibirás un SMS de nuestra parte notificándote que puedes volver a solicitar. ¡Estamos aquí para ayudarte!
                                      </div>
                                  </div>
                              </van-collapse-item>

                              <van-collapse-item :border="hasborder" name="7">
                                  <template #title>
                                      <div class="children_title_wrap">
                                          <div class="children_title_left">
                                              <div class="children_tleft_text">
                                                  ¿Si mi solicitud de préstamo fue rechazada, ¿puedo volver a solicitar?
                                              </div>
                                          </div>
                                      </div>
                                  </template>

                                  <template #right-icon>
                                      <div class="common_title_right" style="padding-top: 0.5rem;">
                                          <div class="common_trview" style="width: 0.666667rem; height: 0.666667rem;">
                                              <img v-if="chidthrIsOpen('7')" src="../assets/imgs/arrow_icon_up.webp" alt="" />
                                              <img v-else src="../assets/imgs/arrow_icon_down.webp" alt="" />
                                          </div>
                                      </div>
                                  </template>

                                  <div class="children_cont">
                                      <div class="children_cont_items">
                                          ¡No te preocupes! En LaLANITAplus, evaluamos tu historial crediticio de manera regular y ajustamos tus límites de préstamo según tu historial. Te recomendamos realizar tus pagos a tiempo y mantener un buen historial. Si tu solicitud no fue aprobada, significa que no cumpliste con los requisitos para obtener un préstamo de LaLANITAplus. Pero si más adelante cumples con ellos, recibirás un SMS notificándote que puedes volver a aplicar.
                                      </div>
                                  </div>
                              </van-collapse-item>

                              <van-collapse-item :border="hasborder" name="8">
                                  <template #title>
                                      <div class="children_title_wrap">
                                          <div class="children_title_left">
                                              <div class="children_tleft_text">
                                                  ¿Puedo solicitar un préstamo si no tengo trabajo?
                                              </div>
                                          </div>
                                      </div>
                                  </template>

                                  <template #right-icon>
                                      <div class="common_title_right" style="padding-top: 0.5rem;">
                                          <div class="common_trview" style="width: 0.666667rem; height: 0.666667rem;">
                                              <img v-if="chidthrIsOpen('8')" src="../assets/imgs/arrow_icon_up.webp" alt="" />
                                              <img v-else src="../assets/imgs/arrow_icon_down.webp" alt="" />
                                          </div>
                                      </div>
                                  </template>

                                  <div class="children_cont">
                                      <div class="children_cont_items">
                                          ¡Claro que sí! Todos enfrentamos momentos difíciles. En LaLANITAplus, hacemos una evaluación integral de tu información personal para ofrecerte un límite de crédito. No rechazamos tu solicitud solo por no tener empleo. Solo asegúrate de que la información que proporciones sea verídica.
                                      </div>
                                  </div>
                              </van-collapse-item>

                              <van-collapse-item :border="hasborder" name="9">
                                  <template #title>
                                      <div class="children_title_wrap">
                                          <div class="children_title_left">
                                              <div class="children_tleft_text">
                                                  ¿Afecta un documento de identidad caducado a mi solicitud de préstamo?
                                              </div>
                                          </div>
                                      </div>
                                  </template>

                                  <template #right-icon>
                                      <div class="common_title_right" style="padding-top: 0.5rem;">
                                          <div class="common_trview" style="width: 0.666667rem; height: 0.666667rem;">
                                              <img v-if="chidthrIsOpen('9')" src="../assets/imgs/arrow_icon_up.webp" alt="" />
                                              <img v-else src="../assets/imgs/arrow_icon_down.webp" alt="" />
                                          </div>
                                      </div>
                                  </template>

                                  <div class="children_cont">
                                      <div class="children_cont_items">
                                          ¡Sí! Si tu identificación no está vigente, esto puede afectar tu solicitud de préstamo. Asegúrate de que tu identificación y la información de tu cuenta bancaria sean válidas antes de solicitar.
                                      </div>
                                  </div>
                              </van-collapse-item>

                              <van-collapse-item :border="hasborder" name="10">
                                  <template #title>
                                      <div class="children_title_wrap">
                                          <div class="children_title_left">
                                              <div class="children_tleft_text">
                                                  ¿El monto del préstamo que solicito es el mismo que recibiré?
                                              </div>
                                          </div>
                                      </div>
                                  </template>

                                  <template #right-icon>
                                      <div class="common_title_right" style="padding-top: 0.5rem;">
                                          <div class="common_trview" style="width: 0.666667rem; height: 0.666667rem;">
                                              <img v-if="chidthrIsOpen('10')" src="../assets/imgs/arrow_icon_up.webp" alt="" />
                                              <img v-else src="../assets/imgs/arrow_icon_down.webp" alt="" />
                                          </div>
                                      </div>
                                  </template>

                                  <div class="children_cont">
                                      <div class="children_cont_items">
                                          ¡Definitivamente! No descontamos ninguna tarifa al momento de tu solicitud. El monto total que solicitas se deposita directamente en la cuenta bancaria que proporcionaste, y la cantidad que recibes será la misma que solicitaste.
                                      </div>
                                  </div>
                              </van-collapse-item>

                              <van-collapse-item :border="hasborder" name="11">
                                  <template #title>
                                      <div class="children_title_wrap">
                                          <div class="children_title_left">
                                              <div class="children_tleft_text">
                                                  ¿Por qué no ha llegado el préstamo a mi cuenta bancaria?
                                              </div>
                                          </div>
                                      </div>
                                  </template>

                                  <template #right-icon>
                                      <div class="common_title_right" style="padding-top: 0.5rem;">
                                          <div class="common_trview" style="width: 0.666667rem; height: 0.666667rem;">
                                              <img v-if="chidthrIsOpen('11')" src="../assets/imgs/arrow_icon_up.webp" alt="" />
                                              <img v-else src="../assets/imgs/arrow_icon_down.webp" alt="" />
                                          </div>
                                      </div>
                                  </template>

                                  <div class="children_cont">
                                      <div class="children_cont_items">
                                          Asegúrate de que tu solicitud haya sido aprobada y verifica que la información de tu cuenta bancaria sea correcta y esté activa. Recuerda que las transferencias pueden tardar un poco más por problemas de red, así que mantén la calma. Te enviaremos una notificación tan pronto como el pago sea exitoso. Generalmente, el dinero se acredita en tu cuenta en menos de 24 horas. Si después de este tiempo no lo has recibido, contacta a nuestro servicio al cliente.
                                          <br/>Teléfono: 5585261054
                                      </div>
                                  </div>
                              </van-collapse-item>

                              <van-collapse-item :border="hasborder" name="12">
                                  <template #title>
                                      <div class="children_title_wrap">
                                          <div class="children_title_left">
                                              <div class="children_tleft_text">
                                                  Mi solicitud de préstamo ha sido aprobada, pero la aplicación dice 'Depositando' por más de 24 horas. ¿Qué debo hacer?
                                              </div>
                                          </div>
                                      </div>
                                  </template>

                                  <template #right-icon>
                                      <div class="common_title_right" style="padding-top: 0.5rem;">
                                          <div class="common_trview" style="width: 0.666667rem; height: 0.666667rem;">
                                              <img v-if="chidthrIsOpen('12')" src="../assets/imgs/arrow_icon_up.webp" alt="" />
                                              <img v-else src="../assets/imgs/arrow_icon_down.webp" alt="" />
                                          </div>
                                      </div>
                                  </template>

                                  <div class="children_cont">
                                      <div class="children_cont_items">
                                          No se preocupe si encuentra este tipo de problema. Llame a nuestro número de servicio al cliente lo antes posible y proporcione la información de su pedido. Resolveremos su problema de préstamo dentro de las 24 horas.
                                      </div>
                                  </div>
                              </van-collapse-item>

                              <van-collapse-item :border="hasborder" name="13">
                                  <template #title>
                                      <div class="children_title_wrap">
                                          <div class="children_title_left">
                                              <div class="children_tleft_text">
                                                  ¿Mi solicitud de préstamo ha sido aprobada, pero no he recibido el dinero ¿Qué debo hacer?
                                              </div>
                                          </div>
                                      </div>
                                  </template>

                                  <template #right-icon>
                                      <div class="common_title_right" style="padding-top: 0.5rem;">
                                          <div class="common_trview" style="width: 0.666667rem; height: 0.666667rem;">
                                              <img v-if="chidthrIsOpen('13')" src="../assets/imgs/arrow_icon_up.webp" alt="" />
                                              <img v-else src="../assets/imgs/arrow_icon_down.webp" alt="" />
                                          </div>
                                      </div>
                                  </template>

                                  <div class="children_cont">
                                      <div class="children_cont_items">
                                          No se preocupe si encuentra este tipo de problema. Llame a nuestro número de servicio al cliente lo antes posible y proporcione la información de su pedido. Resolveremos su problema de préstamo dentro de las 24 horas.
                                      </div>
                                  </div>
                              </van-collapse-item>

                          </van-collapse>
                      </div>

                  </van-tab>
                  <van-tab title="Preguntas de pago">
                      <div class="common_children_wrap">
                          <div class="common_children_title">Cuestion de pago</div>
                          <van-collapse :border="hasborder" v-model="chidtwo_Names">
                              <van-collapse-item :border="hasborder" name="1">
                                  <template #title>
                                      <div class="children_title_wrap">
                                          <div class="children_title_left">
                                              <div class="children_tleft_text">¿Cuáles son las formas de realizar mi pago?</div>
                                          </div>
                                      </div>
                                  </template>

                                  <template #right-icon>
                                      <div class="common_title_right" style="padding-top: 0.5rem;">
                                          <div class="common_trview" style="width: 0.666667rem; height: 0.666667rem;">
                                              <img v-if="chidtwoIsOpen('1')" src="../assets/imgs/arrow_icon_up.webp" alt="" />
                                              <img v-else src="../assets/imgs/arrow_icon_down.webp" alt="" />
                                          </div>
                                      </div>
                                  </template>

                                  <div class="children_cont">
                                      <div class="children_cont_items">¡Pagar es muy fácil! Puedes hacerlo a través de un código de pago en línea. Solo sigue estos sencillos pasos:</div>
                                      <div class="children_cont_items">
                                          ① Copia el cuenta de pago en la interfaz de pago de la app.
                                      </div>
                                      <div class="children_cont_items">
                                          ② Abre tu aplicación de pago de terceros y completa la siguiente información:Banco、Destinatario de la transferencia、Concepto
                                      </div>
                                  </div>
                              </van-collapse-item>

                              <van-collapse-item :border="hasborder" name="2">
                                  <template #title>
                                      <div class="children_title_wrap">
                                          <div class="children_title_left">
                                              <div class="children_tleft_text">¿Dónde puedo ver la fecha de mi pago? </div>
                                          </div>
                                      </div>
                                  </template>

                                  <template #right-icon>
                                      <div class="common_title_right" style="padding-top: 0.5rem;">
                                          <div class="common_trview" style="width: 0.666667rem; height: 0.666667rem;">
                                              <img v-if="chidtwoIsOpen('2')" src="../assets/imgs/arrow_icon_up.webp" alt="" />
                                              <img v-else src="../assets/imgs/arrow_icon_down.webp" alt="" />
                                          </div>
                                      </div>
                                  </template>
                                  <div class="children_cont">
                                      <div class="children_cont_items">
                                          Una vez que tu solicitud de préstamo haya sido aprobada, podrás ver la fecha de tu pago en la página de pago de la app.
                                      </div>
                                  </div>
                              </van-collapse-item>

                              <van-collapse-item :border="hasborder" name="3">
                                  <template #title>
                                      <div class="children_title_wrap">
                                          <div class="children_title_left">
                                              <div class="children_tleft_text">¿Puedo hacer pagos en cuotas?</div>
                                          </div>
                                      </div>
                                  </template>

                                  <template #right-icon>
                                      <div class="common_title_right" style="padding-top: 0.5rem;">
                                          <div class="common_trview" style="width: 0.666667rem; height: 0.666667rem;">
                                              <img v-if="chidtwoIsOpen('3')" src="../assets/imgs/arrow_icon_up.webp" alt="" />
                                              <img v-else src="../assets/imgs/arrow_icon_down.webp" alt="" />
                                          </div>
                                      </div>
                                  </template>
                                  <div class="children_cont">
                                      <div class="children_cont_items">
                                          ¡Claro que sí! Para ayudarte a manejar mejor tus pagos, en LaLANITAplus apoyamos el reembolso en cuotas. Puedes optar por planes de pago que van de 91 a 180 días.
                                      </div>
                                  </div>
                              </van-collapse-item>

                              <van-collapse-item :border="hasborder" name="4">
                                  <template #title>
                                      <div class="children_title_wrap">
                                          <div class="children_title_left">
                                              <div class="children_tleft_text">¿Puedo pagar mi préstamo antes de tiempo?</div>
                                          </div>
                                      </div>
                                  </template>

                                  <template #right-icon>
                                      <div class="common_title_right" style="padding-top: 0.5rem;">
                                          <div class="common_trview" style="width: 0.666667rem; height: 0.666667rem;">
                                              <img v-if="chidtwoIsOpen('4')" src="../assets/imgs/arrow_icon_up.webp" alt="" />
                                              <img v-else src="../assets/imgs/arrow_icon_down.webp" alt="" />
                                          </div>
                                      </div>
                                  </template>
                                  <div class="children_cont">
                                      <div class="children_cont_items">
                                          ¡Por supuesto! En LaLANITAplus, animamos a nuestros usuarios a que paguen sus préstamos anticipadamente. Hacerlo no solo reduce los intereses que pagas, ¡sino que también te ayuda a acumular más crédito para tu próximo préstamo!
                                      </div>
                                  </div>
                              </van-collapse-item>

                              <van-collapse-item :border="hasborder" name="5">
                                  <template #title>
                                      <div class="children_title_wrap">
                                          <div class="children_title_left">
                                              <div class="children_tleft_text">¿Qué pasa si no puedo pagar mi préstamo a tiempo?</div>
                                          </div>
                                      </div>
                                  </template>

                                  <template #right-icon>
                                      <div class="common_title_right" style="padding-top: 0.5rem;">
                                          <div class="common_trview" style="width: 0.666667rem; height: 0.666667rem;">
                                              <img v-if="chidtwoIsOpen('5')" src="../assets/imgs/arrow_icon_up.webp" alt="" />
                                              <img v-else src="../assets/imgs/arrow_icon_down.webp" alt="" />
                                          </div>
                                      </div>
                                  </template>
                                  <div class="children_cont">
                                      <div class="children_cont_items">
                                          Si no realizas tu pago a tiempo, aplicaremos una penalización por demora con intereses después de la fecha de vencimiento. Para evitar estos cargos, te recomendamos pagar tu préstamo lo antes posible. Recuerda que si no pagas a tiempo, también afectará tu historial crediticio con LaLANITAplus, disminuyendo tus límites para futuros préstamos.
                                      </div>
                                  </div>
                              </van-collapse-item>

                              <van-collapse-item :border="hasborder" name="6">
                                  <template #title>
                                      <div class="children_title_wrap">
                                          <div class="children_title_left">
                                              <div class="children_tleft_text">Si me retraso en el pago, ¿será contactado por un representante?</div>
                                          </div>
                                      </div>
                                  </template>

                                  <template #right-icon>
                                      <div class="common_title_right" style="padding-top: 0.5rem;">
                                          <div class="common_trview" style="width: 0.666667rem; height: 0.666667rem;">
                                              <img v-if="chidtwoIsOpen('6')" src="../assets/imgs/arrow_icon_up.webp" alt="" />
                                              <img v-else src="../assets/imgs/arrow_icon_down.webp" alt="" />
                                          </div>
                                      </div>
                                  </template>
                                  <div class="children_cont">
                                      <div class="children_cont_items">
                                          Si no realizas tu pago a tiempo, nuestro equipo de cobranza se pondrá en contacto contigo para ofrecerte soluciones. ¡Pero cuidado! Asegúrate de verificar la información del contacto para evitar fraudes.
                                      </div>
                                  </div>
                              </van-collapse-item>

                              <van-collapse-item :border="hasborder" name="7">
                                  <template #title>
                                      <div class="children_title_wrap">
                                          <div class="children_title_left">
                                              <div class="children_tleft_text">¿Qué hago si accidentalmente pago de más?</div>
                                          </div>
                                      </div>
                                  </template>

                                  <template #right-icon>
                                      <div class="common_title_right" style="padding-top: 0.5rem;">
                                          <div class="common_trview" style="width: 0.666667rem; height: 0.666667rem;">
                                              <img v-if="chidtwoIsOpen('7')" src="../assets/imgs/arrow_icon_up.webp" alt="" />
                                              <img v-else src="../assets/imgs/arrow_icon_down.webp" alt="" />
                                          </div>
                                      </div>
                                  </template>
                                  <div class="children_cont">
                                      <div class="children_cont_items">
                                          ¡No te preocupes! Si por error realizas un pago mayor a la cantidad adeudada, te devolveremos el monto extra. Solo contáctanos de inmediato y estaremos encantados de ayudarte .
                                          <br/>Teléfono: 5585261054
                                      </div>
                                  </div>
                              </van-collapse-item>

                              <van-collapse-item :border="hasborder" name="8">
                                  <template #title>
                                      <div class="children_title_wrap">
                                          <div class="children_title_left">
                                              <div class="children_tleft_text">He pagado, pero la aplicación todavía muestra que hay pedidos que no se han liquidado ¿Qué debo hacer?</div>
                                          </div>
                                      </div>
                                  </template>

                                  <template #right-icon>
                                      <div class="common_title_right" style="padding-top: 0.5rem;">
                                          <div class="common_trview" style="width: 0.666667rem; height: 0.666667rem;">
                                              <img v-if="chidtwoIsOpen('8')" src="../assets/imgs/arrow_icon_up.webp" alt="" />
                                              <img v-else src="../assets/imgs/arrow_icon_down.webp" alt="" />
                                          </div>
                                      </div>
                                  </template>
                                  <div class="children_cont">
                                      <div class="children_cont_items">
                                          No se preocupe si encuentra este tipo de problema. Llame a nuestro número de servicio al cliente lo antes posible y proporcione su información de pago. Resolveremos su problema de pago dentro de las 24 horas.
                                      </div>
                                  </div>
                              </van-collapse-item>
                          </van-collapse>
                      </div>
                  </van-tab>
                  <van-tab title="Preguntas de la App">
                      <div class="common_children_wrap">
                          <div class="common_children_title">Sobre Nosotros</div>
                          <van-collapse :border="hasborder" v-model="chidone_Names">
                              <van-collapse-item :border="hasborder" name="1">
                                  <template #title>
                                      <div class="children_title_wrap">
                                          <div class="children_title_left">
                                              <div class="children_tleft_text">¿Qué es LaLANITAplus? </div>
                                          </div>
                                      </div>
                                  </template>

                                  <template #right-icon>
                                      <div class="common_title_right" style="padding-top: 0.5rem;">
                                          <div class="common_trview" style="width: 0.666667rem; height: 0.666667rem;">
                                              <img v-if="chidoneIsOpen('1')" src="../assets/imgs/arrow_icon_up.webp" alt="" />
                                              <img v-else src="../assets/imgs/arrow_icon_down.webp" alt="" />
                                          </div>
                                      </div>
                                  </template>

                                  <div class="children_cont">
                                      <div class="children_cont_items">
                                          LaLANITAplus es una plataforma segura y confiable para solicitar préstamos en línea. A través de nuestra app disponible para Android e iOS, ofrecemos préstamos inmediatos desde xx pesos hasta xx pesos. ¡El proceso es sencillo, rápido y seguro! Solo completa los datos personales y podrás ver el monto que puedes solicitar, el plazo de pago y la tasa de interés.
                                      </div>
                                      <div class="children_cont_items">Además, somos una empresa financiera registrada y regulada por CONDUSEF, ¡así que puedes estar tranquilo! Tu privacidad y seguridad son nuestra prioridad, y no tienes que preocuparte por la seguridad de tu información personal ni por fraude. Estamos a tu disposición 24/7, los 365 días del año. Si en algún momento necesitas ayuda, no dudes en contactarnos:</div>
                                      <div class="children_cont_items">Correo: servicioplus@lalanitaplus.com</div>
                                      <div class="children_cont_items">Teléfono: 5585261054</div>
                                      <div class="children_cont_items">Whatsapp: 7204712755</div>
                                      <div class="children_cont_items">¡Descarga nuestra app y comienza a disfrutar de una experiencia financiera única! </div>
                                  </div>
                              </van-collapse-item>

                              <van-collapse-item :border="hasborder" name="2">
                                  <template #title>
                                      <div class="children_title_wrap">
                                          <div class="children_title_left">
                                              <div class="children_tleft_text">
                                                  ¿LaLANITAplus es segura?
                                              </div>
                                          </div>
                                      </div>
                                  </template>

                                  <template #right-icon>
                                      <div class="common_title_right" style="padding-top: 0.5rem;">
                                          <div class="common_trview" style="width: 0.666667rem; height: 0.666667rem;">
                                              <img v-if="chidoneIsOpen('2')" src="../assets/imgs/arrow_icon_up.webp" alt="" />
                                              <img v-else src="../assets/imgs/arrow_icon_down.webp" alt="" />
                                          </div>
                                      </div>
                                  </template>
                                  <div class="children_cont">
                                      <div class="children_cont_items">
                                          ¡Claro que sí! Somos una SOFOM (Sociedad Financiera de Objeto Múltiple) registrada en la Comisión Nacional Bancaria y de Valores (CNBV). Además, la Comisión Nacional para la Protección y Defensa de los Usuarios de Servicios Financieros (CONDUSEF) supervisa nuestras operaciones para garantizar que cumplamos con la transparencia y regulación de los servicios financieros.
                                          <br/>
                                          No te preocupes por la seguridad de tus datos personales. Sin tu consentimiento, no compartimos tu información con terceros y la protegemos de acuerdo con nuestra política de privacidad.
                                          <br/>
                                          Por lo tanto, puede estar seguro de solicitar un préstamo con LaLANITAplus.
                                      </div>
                                  </div>
                              </van-collapse-item>

                              <van-collapse-item :border="hasborder" name="3">
                                  <template #title>
                                      <div class="children_title_wrap">
                                          <div class="children_title_left">
                                              <div class="children_tleft_text">
                                                  ¿Cuál es el límite mínimo y máximo de préstamo que puedo obtener en LaLANITAplus?
                                              </div>
                                          </div>
                                      </div>
                                  </template>

                                  <template #right-icon>
                                      <div class="common_title_right" style="padding-top: 0.5rem;">
                                          <div class="common_trview" style="width: 0.666667rem; height: 0.666667rem;">
                                              <img v-if="chidoneIsOpen('3')" src="../assets/imgs/arrow_icon_up.webp" alt="" />
                                              <img v-else src="../assets/imgs/arrow_icon_down.webp" alt="" />
                                          </div>
                                      </div>
                                  </template>
                                  <div class="children_cont">
                                      <div class="children_cont_items">
                                          En LaLANITAplus, puedes obtener préstamos de hasta <span style="font-weight: bold;">20,000</span> pesos. El monto otorgado se evalúa automáticamente según la información personal que proporcionas al momento de la solicitud. ¡Solicita ahora y descubre lo que podemos ofrecerte!
                                      </div>
                                  </div>
                              </van-collapse-item>

                              <van-collapse-item :border="hasborder" name="4">
                                  <template #title>
                                      <div class="children_title_wrap">
                                          <div class="children_title_left">
                                              <div class="children_tleft_text">¿Cómo puedo mejorar mi monto de préstamo en LaLANITAplus?</div>
                                          </div>
                                      </div>
                                  </template>

                                  <template #right-icon>
                                      <div class="common_title_right" style="padding-top: 0.5rem;">
                                          <div class="common_trview" style="width: 0.666667rem; height: 0.666667rem;">
                                              <img v-if="chidoneIsOpen('4')" src="../assets/imgs/arrow_icon_up.webp" alt="" />
                                              <img v-else src="../assets/imgs/arrow_icon_down.webp" alt="" />
                                          </div>
                                      </div>
                                  </template>
                                  <div class="children_cont">
                                      <div class="children_cont_items">
                                          En LaLANITAplus, evaluamos periódicamente tu historial crediticio y ofrecemos montos de préstamo basados en tu calificación. ¡Asegúrate de realizar tus pagos a tiempo para aumentar tu capacidad de préstamo! Si pides préstamos con frecuencia y mantienes un buen historial de pagos, tendrás la oportunidad de acceder a montos más altos. ¡Haz que tu confianza se convierten en mayores oportunidades!
                                      </div>
                                  </div>
                              </van-collapse-item>

                              <van-collapse-item :border="hasborder" name="5">
                                  <template #title>
                                      <div class="children_title_wrap">
                                          <div class="children_title_left">
                                              <div class="children_tleft_text">¿Cuál es la tasa de interés en LaLANITAplus?</div>
                                          </div>
                                      </div>
                                  </template>

                                  <template #right-icon>
                                      <div class="common_title_right" style="padding-top: 0.5rem;">
                                          <div class="common_trview" style="width: 0.666667rem; height: 0.666667rem;">
                                              <img v-if="chidoneIsOpen('5')" src="../assets/imgs/arrow_icon_up.webp" alt="" />
                                              <img v-else src="../assets/imgs/arrow_icon_down.webp" alt="" />
                                          </div>
                                      </div>
                                  </template>
                                  <div class="children_cont">
                                      <div class="children_cont_items">
                                          La tasa de interés en LaLANITAplus se ajusta según tu plan de préstamo, comenzando desde una increíble tasa diaria del <span style="font-weight: bold;">0.09</span>%. Si quieres conocer tasas específicas, realiza una simulación en nuestra página de solicitud de préstamo. ¡Aprovecha nuestras tasas más competitivas!
                                      </div>
                                  </div>
                              </van-collapse-item>

                              <van-collapse-item :border="hasborder" name="6">
                                  <template #title>
                                      <div class="children_title_wrap">
                                          <div class="children_title_left">
                                              <div class="children_tleft_text">¿Hay descuentos en la tasa de interés si realizo múltiples préstamos?</div>
                                          </div>
                                      </div>
                                  </template>

                                  <template #right-icon>
                                      <div class="common_title_right" style="padding-top: 0.5rem;">
                                          <div class="common_trview" style="width: 0.666667rem; height: 0.666667rem;">
                                              <img v-if="chidoneIsOpen('6')" src="../assets/imgs/arrow_icon_up.webp" alt="" />
                                              <img v-else src="../assets/imgs/arrow_icon_down.webp" alt="" />
                                          </div>
                                      </div>
                                  </template>
                                  <div class="children_cont">
                                      <div class="children_cont_items">
                                          La tasa de interés depende únicamente del monto del préstamo y el período de pago, pero ¡tenemos sorpresas para ti! De vez en cuando, organizamos actividades especiales y otorgamos diferentes tipos de regalos o cupones que permiten disfrutar los descuentos en tus intereses. ¡No te lo pierdas!
                                      </div>
                                  </div>
                              </van-collapse-item>

                              <van-collapse-item :border="hasborder" name="7">
                                  <template #title>
                                      <div class="children_title_wrap">
                                          <div class="children_title_left">
                                              <div class="children_tleft_text">¿Qué debo hacer si robaron o perdi mi teléfono ?</div>
                                          </div>
                                      </div>
                                  </template>

                                  <template #right-icon>
                                      <div class="common_title_right" style="padding-top: 0.5rem;">
                                          <div class="common_trview" style="width: 0.666667rem; height: 0.666667rem;">
                                              <img v-if="chidoneIsOpen('7')" src="../assets/imgs/arrow_icon_up.webp" alt="" />
                                              <img v-else src="../assets/imgs/arrow_icon_down.webp" alt="" />
                                          </div>
                                      </div>
                                  </template>
                                  <div class="children_cont">
                                      <div class="children_cont_items">
                                          ¡No te preocupes! Si robaron o perdiste tu teléfono, puedes contactar a nuestro servicio al cliente para cancelar tu cuenta original de inmediato.
                                      </div>
                                      <div class="children_cont_items">
                                          Email: servicioplus@lalanitaplus.com
                                      </div>
                                      <div class="children_cont_items">
                                          Teléfono: 5585261054
                                      </div>
                                      <div class="children_cont_items">
                                          Whatsapp: 7204712755
                                      </div>
                                  </div>
                              </van-collapse-item>

                              <van-collapse-item :border="hasborder" name="8">
                                  <template #title>
                                      <div class="children_title_wrap">
                                          <div class="children_title_left">
                                              <div class="children_tleft_text">¿Cómo puedo verificar si un correo electrónico, mensaje o llamada sospechosos de fraudes son de LaLANITAplus?</div>
                                          </div>
                                      </div>
                                  </template>

                                  <template #right-icon>
                                      <div class="common_title_right" style="padding-top: 0.5rem;">
                                          <div class="common_trview" style="width: 0.666667rem; height: 0.666667rem;">
                                              <img v-if="chidoneIsOpen('8')" src="../assets/imgs/arrow_icon_up.webp" alt="" />
                                              <img v-else src="../assets/imgs/arrow_icon_down.webp" alt="" />
                                          </div>
                                      </div>
                                  </template>
                                  <div class="children_cont">
                                      <div class="children_cont_items">
                                          ¡Nunca enviamos información a través de canales no oficiales!
                                      </div>
                                      <div class="children_cont_items">
                                          Si no estás seguro de haber recibido un correo electrónico, mensaje o llamada fraudulenta, puedes contactarnos para verificar. Aquí tienes nuestros datos oficiales:
                                      </div>
                                      <div class="children_cont_items">
                                          Email: servicioplus@lalanitaplus.com
                                      </div>
                                      <div class="children_cont_items">
                                          Teléfono: 5585261054
                                      </div>
                                      <div class="children_cont_items">
                                          Whatsapp: 7204712755
                                      </div>
                                  </div>
                              </van-collapse-item>

                              <van-collapse-item :border="hasborder" name="9">
                                  <template #title>
                                      <div class="children_title_wrap">
                                          <div class="children_title_left">
                                              <div class="children_tleft_text">¿Cómo puedo reportar fraude?</div>
                                          </div>
                                      </div>
                                  </template>

                                  <template #right-icon>
                                      <div class="common_title_right" style="padding-top: 0.5rem;">
                                          <div class="common_trview" style="width: 0.666667rem; height: 0.666667rem;">
                                              <img v-if="chidoneIsOpen('9')" src="../assets/imgs/arrow_icon_up.webp" alt="" />
                                              <img v-else src="../assets/imgs/arrow_icon_down.webp" alt="" />
                                          </div>
                                      </div>
                                  </template>
                                  <div class="children_cont">
                                      <div class="children_cont_items">
                                          Si recibes un correo electrónico, mensaje o llamada sospechosos, puedes reportarlos a nuestro servicio al cliente. ¡Te animamos a que nos ayudes a combatir el fraude! Si la información que proporcionas resulta ser válida, recompensamos con un regalo o un cupón, ¡como agradecimiento!
                                      </div>
                                      <div class="children_cont_items">
                                          Nuestros datos de contacto:
                                      </div>
                                      <div class="children_cont_items">
                                          Email: servicioplus@lalanitaplus.com
                                      </div>
                                      <div class="children_cont_items">
                                          Teléfono: 5585261054
                                      </div>
                                      <div class="children_cont_items">
                                          Whatsapp: 7204712755
                                      </div>
                                  </div>
                              </van-collapse-item>
                          </van-collapse>
                      </div>
                  </van-tab>
              </van-tabs>
          </div>
      </div>
      <mobFooter></mobFooter>
   </div>
</template>

<script>
import headNav from "@/components/headNav.vue";
import homeNav from "@/components/homeNav.vue";
import footPage from "@/components/foot.vue";
import "../components/scss/sobre.scss";
import mobNav from "@/components/mobNav.vue";
import mobFooter from "@/components/mobfooter.vue";
import mobileOrpc from "@/mixins/index";

export default {
    name: "Sobre",
    components: { headNav, homeNav, footPage, mobNav, mobFooter },
    mixins: [mobileOrpc],
    data() {
      return {
          activeNav: "sobre",
          scroll: 0,
          isaccordion: true,
          hasborder: false,
          activeNames: [],
          chidone_Names: [],
          chidtwo_Names: [],
          chidthr_Names: [],
          chidfur_Names: [],
          chidfiv_Names: [],
      }
    },
    mounted(){
      window.addEventListener('scroll',this.handleScroll)
      document.body.scrollTop = document.documentElement.scrollTop=0;
    },
    methods: {
        gotoWhatsApp() {
            window.android.callWhatsapp('5568827728')
        },
        gotoPhone() {
            window.location.href = 'tel:' + 5585266878
        },
        handleCopy(address) {
            let url = address
            let copyInput = document.createElement('input')
            document.body.appendChild(copyInput)
            copyInput.setAttribute('value', url)
            copyInput.select()
            document.execCommand('Copy')
            //toast({ time: 2000, content: 'La copia del buzón fue exitosa' })
            copyInput.remove()
        },
        collapseIsOpen(index) {
            let useActiveNames = this.activeNames
            let isOpen = useActiveNames.indexOf(index)

            if (isOpen == -1) {
                return false
            } else {
                return true
            }
        },
        chidoneIsOpen(index) {
            let useActiveNames = this.chidone_Names
            let isOpen = useActiveNames.indexOf(index)

            if (isOpen == -1) {
                return false
            } else {
                return true
            }
        },
        chidtwoIsOpen(index) {
            let useActiveNames = this.chidtwo_Names
            let isOpen = useActiveNames.indexOf(index)

            if (isOpen == -1) {
                return false
            } else {
                return true
            }
        },
        chidthrIsOpen(index) {
            let useActiveNames = this.chidthr_Names
            let isOpen = useActiveNames.indexOf(index)

            if (isOpen == -1) {
                return false
            } else {
                return true
            }
        },
        chidfurIsOpen(index) {
            let useActiveNames = this.chidfur_Names
            let isOpen = useActiveNames.indexOf(index)

            if (isOpen == -1) {
                return false
            } else {
                return true
            }
        },
        chidfivIsOpen(index) {
            let useActiveNames = this.chidfiv_Names
            let isOpen = useActiveNames.indexOf(index)

            if (isOpen == -1) {
                return false
            } else {
                return true
            }
        },
        collapseChange(e) {
            console.log(e)
        },
        handleScroll(){
            //或者使用document.querySelector('.class或者#id').scrollTop
            this.scroll = document.documentElement.scrollTop||document.body.scrollTop
        },
    },
    //销毁,否则跳到别的路由还是会出现
    destroyed() {
      window.removeEventListener('scroll', this.handleScroll)
    }
}
</script>

<style>
  .eshoy_about_wrap{
    width: 100%;
    height: auto;
    padding: 90px 0 140px 0;
    background: #FBF9F9;
  }
  .eshoy_abtitle_cont{
    width: 100%;
    height: auto;
    padding-bottom: 80px;
  }
  .eshoy_abtitle_icon{
    width: 54px;
    height: 54px;
    margin: 0 auto;
  }
  .eshoy_abtitle_view{
    width: 100%;
    height: 30px;
    padding-top: 18px;
    font-size: 30px;
    font-family: MiSans-Semibold, MiSans;
    font-weight: 600;
    color: #391C10;
    line-height: 30px;
    text-align: center;
  }
  .eshoy_abtitle_icon img{
    display: block;
    width: 100%;
  }
  .eshoy_abmessage_cont{
    width: 1200px;
    height: auto;
    background: #FFFFFF;
    box-shadow: 0px 25px 50px 0px rgba(69,69,69,0.04);
    border-radius: 20px;
    border: 1px solid #EFECEA;
    margin: 0 auto;
    box-sizing: border-box;
    padding: 63px 64px 65px 64px;
  }
  .eshoy_abmessage_title{
    width: 100%;
    height: 22px;
    font-size: 22px;
    font-family: MiSans-Semibold, MiSans;
    font-weight: 600;
    color: #453D39;
    line-height: 22px;
  }
  .eshoy_abmessage_view{
    width: 100%;
    height: auto;
    padding-top: 24px;
    font-size: 18px;
    font-family: MiSans-Regular, MiSans;
    font-weight: 400;
    color: #453D39;
    line-height: 33px;
  }
  .fotop_cont_dit_img img{
    display: block;
    width: 100%;
  }
  .eshoy_content_wrap{
    width: 100%;
    height: auto;
    position: relative;
  }
  .plabout_wrap{
      width: 100%;
      height: auto;
      background: #13151A;
      padding-top: 120px;
  }
  .plabout_cont{
      width: 1200px;
      height: auto;
      padding-bottom: 120px;
      margin: 0 auto;
  }
  .plabout_cont img{
      display: block;
      width: 100%;
  }
  .lalanitasobre_1v{
      width: 1400px;
      height: auto;
      margin: 0 auto;
      padding: 196px 0 0 0;
  }

  #lalanitasobre_mobile .van-collapse{
      background: none !important;
  }
  #lalanitasobre_mobile .van-collapse-item__content{
      background: none !important;
  }
  #lalanitasobre_mobile .van-cell {
      padding: 0;
      background-color: #ffffff;
  }
  #lalanitasobre_mobile .van-collapse-item {
      background-color: #ffffff;
  }
  #lalanitasobre_mobile .van-cell--clickable:active {
      background-color: #ffffff;
  }
  #lalanitasobre_mobile .van-collapse-item__content {
      padding: 0;
      background-color: #FEFAF8;
  }
  .mobile_viewrap .common_problem_wrap{
      width: 100%;
  }
  #lalanitasobre_mobile .common_problem_wrap {
      width: 100%;
      padding-top: 0.26rem;
      padding-bottom: 3.888889rem;
  }
  #lalanitasobre_mobile .common_title_wrap {
      width: 100%;
      height: 1.222222rem;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      box-sizing: border-box;
      padding: 0 0 0 0.694444rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
  }
  #lalanitasobre_mobile .common_title_left {
      width: auto;
      height: 0.666667rem;
      display: flex;
      justify-content: flex-start;
      align-items: center;
  }
  #lalanitasobre_mobile .common_tleft_icon {
      width: 0.666667rem;
      height: 0.666667rem;
  }
  #lalanitasobre_mobile .common_tleft_icon img {
      display: block;
      width: 100%;
  }
  #lalanitasobre_mobile .common_tleft_text {
      width: auto;
      padding-left: 0.277778rem;
      font-size: 0.388889rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #8c8e94;
  }
  #lalanitasobre_mobile .common_title_left .isopen {
      color: #3CCA8C;
  }
  #lalanitasobre_mobile .common_title_right {
      width: auto;
      height: 1.222222rem;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      box-sizing: border-box;
      padding-right: 0.444444rem;
  }
  #lalanitasobre_mobile .common_trview {
      width: 0.277778rem;
      height: 0.277778rem;
  }
  #lalanitasobre_mobile .common_trview img {
      display: block;
      width: 100%;
  }
  #lalanitasobre_mobile .common_children_wrap {
      width: 100%;
      box-sizing: border-box;
      padding-left: 0.555556rem;
      padding-bottom: 0.555556rem;
  }
  #lalanitasobre_mobile .children_title_wrap {
      width: 100%;
      height: auto;
      padding-top: 0.555556rem;
      background: none;
  }
  #lalanitasobre_mobile .children_title_left {
      width: 100%;
      height: auto;
      display: flex;
      justify-content: flex-start;
  }
  #lalanitasobre_mobile .children_tleft_icon {
      width: 0.5rem;
      height: 0.472222rem;
      display: flex;
      justify-content: flex-start;
      align-items: center;
  }
  #lalanitasobre_mobile .children_tleft_icon img {
      display: block;
      width: 0.277778rem;
      height: 0.277778rem;
  }
  #lalanitasobre_mobile .children_tleft_text {
      width: 100%;
      height: auto;
      box-sizing: border-box;
      padding-left: 0.444444rem;
      padding-right: 1.055556rem;
      font-size: 0.333333rem;
      font-weight: 400;
      color: #444444;
      line-height: 0.472222rem;
  }
  #lalanitasobre_mobile .children_cont {
      width: 100%;
      height: auto;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      box-sizing: border-box;
      padding: 0.222222rem 1.055556rem 0 0.472222rem;
      overflow-y: scroll;
  }
  #lalanitasobre_mobile .children_cont_items {
      width: 100%;
      height: auto;
      font-size: 0.277778rem;
      color: #777777;
      line-height: 0.555556rem;
  }
  #lalanitasobre_mobile .common_children_wrap .van-cell {
      background-color: #FEFAF8 !important;
      border-radius: 0.333333rem;
  }
  #lalanitasobre_mobile .common_children_wrap .van-collapse-item {
      background-color: #FEFAF8 !important;
      border-radius: 0.333333rem;
      margin-top: 0.444444rem;
      padding-bottom: 0.444444rem;
  }
  #lalanitasobre_mobile .common_children_wrap .van-cell--clickable:active {
      background-color: #FEFAF8 !important;
  }
  #lalanitasobre_mobile .common_problem_tab{
      width: 100%;
      height: auto;
  }
  #common_problem_tabs .van-tabs__wrap{
      width: 91.11vw;
      height: 1.222222rem;
      background: #F5F5F5;
      margin: 0 auto;
      box-sizing: border-box;
      border: 1px solid #F5F5F5;
      border-radius: 0.611111rem;
  }
  #common_problem_tabs .van-tabs__nav--card{
      width: 100%;
      height: 1.222222rem;
      margin: 0;
      border-radius: 0.611111rem;
      box-sizing: border-box;
      padding: 0.09rem 0.111111rem 0.111111rem 0.111111rem;
      border: none;
      background: #F5F5F5;
  }
  #common_problem_tabs .van-tab.van-tab--active{
      border-radius: 0.611111rem;
      background: #3CCA8C;
      color: #ffffff;
  }
  #common_problem_tabs .van-tab{
      height: 1.0rem;
      border: none;
      color: #8E9190;
  }
  #common_problem_tabs .van-tab__text--ellipsis{
      width: 70%;
      overflow: visible;
      -webkit-line-clamp: 2;
      margin: 0 auto;
      line-height: 0.333333rem;
      text-align: center;
  }
  .common_children_title{
      width: 100%;
      font-weight: bold;
      font-size: 16px;
      color: #444444;
      line-height: 19px;
      text-align: left;
      font-style: normal;
      margin-top: 20px;
  }
    #lalanitasobre_pcmax .common_problem_wrap{
        width: 100%;
        height: auto;
    }
  #lalanitasobre_pcmax #common_problem_tabs .van-tabs__wrap{
      width: 1208px;
  }
  #lalanitasobre_pcmax .common_title_right{
      padding-right: 0;
  }
  #lalanitasobre_pcmax .van-collapse{
      background: none !important;
  }
  #lalanitasobre_pcmax .van-collapse-item{
      background: none !important;
  }
  #lalanitasobre_pcmax .van-cell{
      width: 100%;
      background: none !important;
  }
  #lalanitasobre_pcmax .common_children_title{
      font-size: 48px;
      text-align: center;
      height: 185px;
      line-height: 185px;
  }
  #lalanitasobre_pcmax .children_title_wrap{
      background: none;
  }
  #lalanitasobre_pcmax .children_tleft_text {
      color: #000000;
      font-size: 28px;
      font-weight: bold;
      line-height: 38px;
  }
  #lalanitasobre_pcmax .van-collapse-item__content{
      background: none !important;
  }
  #lalanitasobre_pcmax .children_cont{
      overflow-y: visible;
  }
  #lalanitasobre_pcmax .van-tabs__wrap{
      width: 100%;
      height: 104px;
      border-radius: 52px;
  }
  #lalanitasobre_pcmax .van-tabs__nav--card{
      height: 104px;
      padding: 7px 8px 8px 8px;
  }
  #lalanitasobre_pcmax .van-tab{
      width: 388px;
      height: 88px;
  }
  #lalanitasobre_pcmax .van-tab.van-tab--active{
      width: 388px;
      height: 88px;
      border-radius: 44px;
  }
  #lalanitasobre_pcmax .van-tab__text--ellipsis{
      font-weight: bold;
      font-size: 26px;
  }

  #lalanitasobre_pcmax .common_children_wrap .van-collapse-item:nth-child(1){
      background-color: #FEFAF8 !important;
      border-radius: 0.333333rem;
      margin-top: 0.444444rem;
      padding-bottom: 0.444444rem;
  }
  #lalanitasobre_pcmax .common_children_wrap .van-collapse-item:nth-child(2){
      background-color: #F8F8F8 !important;
      border-radius: 0.333333rem;
      margin-top: 0.444444rem;
      padding-bottom: 0.444444rem;
  }
  #lalanitasobre_pcmax .common_children_wrap .van-collapse-item:nth-child(3){
      background-color: #FEFAF8 !important;
      border-radius: 0.333333rem;
      margin-top: 0.444444rem;
      padding-bottom: 0.444444rem;
  }
  #lalanitasobre_pcmax .common_children_wrap .van-collapse-item:nth-child(4){
      background-color: #F8F8F8 !important;
      border-radius: 0.333333rem;
      margin-top: 0.444444rem;
      padding-bottom: 0.444444rem;
  }
  #lalanitasobre_pcmax .common_children_wrap .van-collapse-item:nth-child(5){
      background-color: #FEFAF8 !important;
      border-radius: 0.333333rem;
      margin-top: 0.444444rem;
      padding-bottom: 0.444444rem;
  }
  #lalanitasobre_pcmax .common_children_wrap .van-collapse-item:nth-child(6){
      background-color: #F8F8F8 !important;
      border-radius: 0.333333rem;
      margin-top: 0.444444rem;
      padding-bottom: 0.444444rem;
  }
  #lalanitasobre_pcmax .common_children_wrap .van-collapse-item:nth-child(7){
      background-color: #FEFAF8 !important;
      border-radius: 0.333333rem;
      margin-top: 0.444444rem;
      padding-bottom: 0.444444rem;
  }
  #lalanitasobre_pcmax .common_children_wrap .van-collapse-item:nth-child(8){
      background-color: #F8F8F8 !important;
      border-radius: 0.333333rem;
      margin-top: 0.444444rem;
      padding-bottom: 0.444444rem;
  }
  #lalanitasobre_pcmax .common_children_wrap .van-collapse-item:nth-child(9){
      background-color: #FEFAF8 !important;
      border-radius: 0.333333rem;
      margin-top: 0.444444rem;
      padding-bottom: 0.444444rem;
  }
  #lalanitasobre_pcmax .common_children_wrap .van-collapse-item:nth-child(10){
      background-color: #F8F8F8 !important;
      border-radius: 0.333333rem;
      margin-top: 0.444444rem;
      padding-bottom: 0.444444rem;
  }
  #lalanitasobre_pcmax .common_children_wrap .van-collapse-item:nth-child(11){
      background-color: #FEFAF8 !important;
      border-radius: 0.333333rem;
      margin-top: 0.444444rem;
      padding-bottom: 0.444444rem;
  }
  #lalanitasobre_pcmax .common_children_wrap .van-collapse-item:nth-child(12){
      background-color: #F8F8F8 !important;
      border-radius: 0.333333rem;
      margin-top: 0.444444rem;
      padding-bottom: 0.444444rem;
  }
  #lalanitasobre_pcmax .common_children_wrap .van-collapse-item:nth-child(13){
      background-color: #FEFAF8 !important;
      border-radius: 0.333333rem;
      margin-top: 0.444444rem;
      padding-bottom: 0.444444rem;
  }
  #lalanitasobre_pcmax .children_cont_items{
      font-size: 26px;
      line-height: 34px;
      color: #777777;
  }
  #lalanitasobre_pcmax .van-cell{
      padding: 10px 32px;
  }
    .children_solid_v{
        width: 100%;
        height: 28px;
        box-sizing: border-box;
        padding: 0 12px;
    }
    .children_solid{
        width: 100%;
        height: 1px;
        background: #E2E2E2;
    }
</style>
